import { Injectable } from '@angular/core';
import { ApiService } from 'projects/services/src/app/API/api.service';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { Observable, BehaviorSubject, of } from 'rxjs';
import { Subject } from 'rxjs';

import { environment } from 'src/environments/environment';
import { SqaService } from 'projects/services/src/app/API/sqa.service';


@Injectable({ providedIn: 'root' })
export class ScpwDataService {
	profileActive: BehaviorSubject < boolean > = new BehaviorSubject < boolean > (false);
	private subject = new Subject < any > ();
	scpwForm: FormGroup;
	isSave = true;
	selectedExpository: any;
	ApprovedStatus: any;
	coreId: string;
	constructor(
		private _router: Router,
		private _activatedRoute: ActivatedRoute,
		private _formBuilder: FormBuilder,
		private _sqaService: SqaService,
		private apiService: ApiService
	) {
		this.defineForm();
	}

	getScpwForm(): Observable < any > {
		// return this.subject.asObservable();
		return of(this.scpwForm);
	}

	setScpwForm(formValues) {
		this.scpwForm.patchValue(formValues);
	}

	scollPage() {
		window.scrollTo(0, 0);
	}

	resetForm() {
		this.isSave = true;
		this.defineForm();
	}

	addTrainingToolsStr(value) {
		value.filter(x => {
			this.trainingToolsStr.push(this.createTrainingToolsStr());
		});
		// console.log(this.trainingToolsStr)
	}

	createTrainingToolsStr(tool ? : any): FormGroup {
		return this._formBuilder.group({
			toolName: [tool ? tool.toolName : '', [Validators.required]],
			descOfTool: [tool ? tool.descOfTool : '', [Validators.required]],
			howtoUseThisTool: [tool ? tool.howtoUseThisTool : '', [Validators.required]],
			whenToUseThisTool: [tool ? tool.whenToUseThisTool : '', [Validators.required]],
			acceToolsOrAppOrSw: [tool ? tool.acceToolsOrAppOrSw : '', [Validators.required]]
		});
	}

	get trainingToolsStr(): FormArray {
		return this.scpwForm.get('trainingToolsStr') as FormArray;
	}

	defineForm(data ? : any) {
		this.scpwForm = this._formBuilder.group({
			status: [data ? data.status : 'Draft'],
			expoName: [data ? data.expoName : '', [Validators.required]],
			nomeAsPerAct: [data ? data.nomeAsPerAct : '', [Validators.required]], // ^SCP[\/]E[0-9]{4}$
			expoCode: [{
					value: data ? data.expoCode : '',
					disabled: false
				},
				[Validators.required, Validators.pattern('^SCP\/E[0-9]{4}$')]
			],
			defExpository: [data ? data.defExpository : '', [Validators.required]],
			severityLevels: [data ? data.severityLevels : ''],
			version: [data ? data.version : ''],
			trainingToolsStr: this._formBuilder.array([
				/*_formBuilder.group({
					toolName: ['', [Validators.required]],
					descOfTool: ['', [Validators.required]],
					howtoUseThisTool: ['', [Validators.required]],
					whenToUseThisTool: ['', [Validators.required]],
					acceToolsOrAppOrSw: ['', [Validators.required]]
				})*/
			])
		});
		if (data) {
			this.selectedExpository = data;
			data.trainingToolsStr.filter(x => {
				this.trainingToolsStr.push(this.createTrainingToolsStr(x));
			});
			this.scpwForm.addControl(
				'assessmentGuidelinesStr', this._formBuilder.group({
					briefAbtAssessment: [data.assessmentGuidelinesStr.briefAbtAssessment, [Validators.required]],
					genGuidlines: [data.assessmentGuidelinesStr.genGuidlines, [Validators.required]],
					labAssessmentDet: [data.assessmentGuidelinesStr.labAssessmentDet, [Validators.required]],
					compAssessment: [data.assessmentGuidelinesStr.compAssessment, [Validators.required]]
				}));
			this.scpwForm.addControl(
				'document', this._formBuilder.group({
					documentName: [data ? data.document.documentName : '', [Validators.required]],
					documentURL: [data ? data.document.documentURL : '', [Validators.required]],
					documentUploadedBy: [data ? data.document.documentUploadedBy : '', [Validators.required]]
				}));
			/* this.scpwForm.addControl('reviews', this._formBuilder.group({
				reviewCommentsHistory: this._formBuilder.array([])
			}));

			data.reviews.reviewCommentsHistory.filter(x => {
				// console.log('reviews ', x);
				this.reviewCommentsHistory.push(this.createReviewHistory(x));
			}); */
			// console.log(this.scpwForm.value);

		} else {
			this.scpwForm.addControl(
				'assessmentGuidelinesStr', this._formBuilder.group({
					// briefAbtAssessment: ['', [Validators.required]],
					// genGuidlines: ['', [Validators.required]],
					// labAssessmentDet: ['', [Validators.required]],
					// compAssessment: ['', [Validators.required]]
				}));
			this.scpwForm.addControl(
				'document', this._formBuilder.group({})
			);
		}
		// console.log(this.scpwForm.value);
		// console.log(this.scpwForm);
	}

	/* get reviewCommentsHistory(): FormArray {
		return this.scpwForm.get('reviews').get('reviewCommentsHistory') as FormArray;
	}

	createReviewHistory(data: any): FormGroup {
		return this._formBuilder.group({
			reviewHistoryDate: data.reviewHistoryDate,
			expoName: data.expoName,
			nomeAsPerAct: data.nomeAsPerAct,
			defExpository: data.defExpository,
			severityLevels: data.severityLevels,
			reviewComment: data.reviewComment,
			isCompliant: (data.isCompliant === undefined) ? false : true
		});
	} */

	getAllDisabilityTypes() {
		const getAllDisabilityTypesUrl = environment.nsdcCommonServiceUrl + '/api/nsdccommon/disability/v';
		return this.apiService.get(getAllDisabilityTypesUrl);
	}

	getAllDisabilityCategories() {
		const url = environment.nsdcCommonServiceUrl + '/api/nsdccommon/disabilitycategory/1';
		return this.apiService.get(url);
	}

	getAllExpositoryStatus() {
		const url = environment.sqaServiceUrl + '/api/sqa/expository/status';
		return this.apiService.get(url);
	}

	saveNewExpository(data: any): Observable < any > {
		const SaveExpositoryUrl = environment.sqaServiceUrl + '/api/sqa/expository';
		return this.apiService.post(SaveExpositoryUrl, data);
	}

	UpdateExpositoryDetails(data: any) {
		const UpdateExpositoryUrl = environment.sqaServiceUrl + '/api/sqa/expository';
		return this.apiService.put(UpdateExpositoryUrl, data);
	}

	saveLinkExpoToQpDetails(data: any): Observable < any > {
		const saveLinkExpoQpUrl = environment.sqaServiceUrl + '/api/sqa/qp/borrow';
		return this.apiService.post(saveLinkExpoQpUrl, data);
	}

	updateBorrowQpRequest(data: any): Observable < any > {
		const updateLinkExpoQpUrl = environment.sqaServiceUrl + '/api/sqa/qp/borrow';
		return this.apiService.put(updateLinkExpoQpUrl, data);
	}

	getAllBorrowedQpDetails(pageNo, itemPerPage, query ? ) {
		let queryParams = {};
		queryParams['pageNo'] = pageNo;
		queryParams['itemsPerPage'] = itemPerPage;
		if (query) {
			queryParams = Object.assign({}, queryParams, query);
		}

		const getAllDetailsUrl = environment.sqaServiceUrl + '/api/sqa/qp/borrow/filter';
		return this.apiService.get(getAllDetailsUrl, queryParams);
	}

	getBorrowQpDataBySearch(data: {
		qpCode,
		pageno ? : number,
		size ? : number,
		sectorID ? : any,
		subsectorID ? : any,
		status ? : any,
		nsqf ? : any
	}) {

		data.qpCode = data.qpCode ? data.qpCode : '';
		console.log('params', data.qpCode)
		if (data.status && data.status !== '') {
			data.sectorID = data.sectorID && data.sectorID !== '' ? 'sectorID:' + data.sectorID + ',' : '';
			data.subsectorID = data.subsectorID && data.subsectorID !== '' ? 'subSectorID:' + data.subsectorID + ',' : '';
			data.status = 'statusID:' + data.status;
			data.nsqf = data.nsqf && data.nsqf !== 'All' ? 'nsqfLevel:' + data.nsqf + ',' : ''
			// data.nsqf = '';

		} else if (data.nsqf && data.nsqf !== 'All') {
			data.sectorID = data.sectorID && data.sectorID !== '' ? 'sectorID:' + data.sectorID + ',' : '';
			data.subsectorID = data.subsectorID && data.subsectorID !== '' ? ',subSectorID:' + data.subsectorID : '';
			data.status = '';
			data.nsqf = data.nsqf && data.nsqf !== 'All' ? 'nsqfLevel:' + data.nsqf : ''
		} else {
			data.sectorID = data.sectorID && data.sectorID !== '' ? 'sectorID:' + data.sectorID : '';
			data.subsectorID = data.subsectorID && data.subsectorID !== '' ? ',subSectorID:' + data.subsectorID : '';
			data.status = '';
			data.nsqf = ''
		}
		const dataSearchURL = `${environment.sqaServiceUrl}/api/sqa/qp/borrow/filter?
		matches=${data.sectorID}${data.subsectorID}${data.nsqf}${data.status}&keyword=${data.qpCode}&pageNo=${data.pageno}&size=${data.size}`;
		return this.apiService.get(dataSearchURL);
	}

	getExpoDataByReqId(reqId: any) {
		const getExpoDataByReqIdUrl = `${environment.sqaServiceUrl}/api/sqa/qp/borrow?reqID=${reqId}`;
		return this.apiService.get(getExpoDataByReqIdUrl);
	}

	getExpoDataByReqCode(reqCode: any) {
		const getExpoDataByReqIdUrl = `${environment.sqaServiceUrl}/api/sqa/qp/borrow?reqCode=${reqCode}`;
		return this.apiService.get(getExpoDataByReqIdUrl);
	}

	deleteBorrowQpRequest(reqID: any) {
		const deleteBorrowQpRequestUrl = `${environment.sqaServiceUrl}/api/sqa/qp/borrow?reqID=${reqID}`;
		return this.apiService.delete(deleteBorrowQpRequestUrl);
	}

	requestForCallback(data: any): Observable < any > {
		const SaveExpositoryUrl = environment.sqaServiceUrl + '/api/sqa/expository';
		return this.apiService.put(SaveExpositoryUrl, data);
	}

	getViewAllExpositoryDetails(pageNo, itemPerPage, query ? , status ? ) {
		let queryParams = {};
		queryParams['pageNo'] = pageNo;
		queryParams['itemsPerPage'] = itemPerPage;
		if (query) {
			queryParams = Object.assign({}, queryParams, query);
		}
		if (status === 'Standards Approved') {
			this.ApprovedStatus = `filter?matches=statusID:08`
		} else {
			this.ApprovedStatus = 'filter'
		}
		const getViewAllDetailsUrl = environment.sqaServiceUrl + `/api/sqa/expository/${this.ApprovedStatus}`;
		return this.apiService.get(getViewAllDetailsUrl, queryParams);
	}

	deleteExpository(exptmpID: any, expoversion: any) {
		const deleteExpositoryUrl = `${environment.sqaServiceUrl}/api/sqa/expository?tempID=${exptmpID}&version=${expoversion}`;
		return this.apiService.delete(deleteExpositoryUrl, {
			tempID: exptmpID,
			version: expoversion
		});
	}

	getViewExpository(id: any) {
		const getExpositoryUrl = `${environment.sqaServiceUrl}/api/sqa/expository/filter?matches=exptmpID:${id}`;
		return this.apiService.get(getExpositoryUrl);
	}


	getViewExpositoryDetails(expoCode: any, version: any) {
		const getExpositoryDetailsUrl = `${environment.sqaServiceUrl}/api/sqa/expository?expoCode=${expoCode}&version=${version}`;
		return this.apiService.get(getExpositoryDetailsUrl);
	}

	getAllOtherSectorData(search ? : any, pageno ? : number, size ? : number, standardsTeam ? : boolean, coreSector ? : boolean) {
		console.log(search.status)
		console.log(coreSector)
		if (coreSector === false) {
			if (search.sectorID == 40) {
				this.coreId = 'excludeSectorID';
			} else {
				this.coreId = 'excludeSectorID:40,sectorID';
			}
		} else {
			this.coreId = 'sectorID';
			if (search.sectorID !== 40) {
				search.sectorID = 40
			}

		}
		console.log(this.coreId)
		// tslint:disable-next-line:max-line-length
		let searchUrl = (search.sectorID !== 'All') ? `${this.coreId}:${search.sectorID}` : ``;
		searchUrl += (search.subSectorID !== 'All' && search.subSectorID !== '') ? `,subSectorID:${search.subSectorID}` : ``;
		searchUrl += (search.nsqf !== 'All') ? `,nsqf:${search.nsqf}` : ``;
		searchUrl += (search.status !== 'All') ? `,status:${search.status.statusDesc}` : ``;
		// tslint:disable-next-line:max-line-length
		const qpDataURL = standardsTeam ? `${environment.sqaServiceUrl}/api/sqa/qp/search?pageNo=${pageno}&&size=${size}&&search=${searchUrl}&keyword=${search.keyword}&
			&fields=qpCode,status,sectors,nsqfLevel,occupation,qpTempID,createdOn,jobRole,country,reviews,version&search=standardsTeam:true` :
			`${environment.sqaServiceUrl}/api/sqa/qp/search?search=${searchUrl}&keyword=${search.keyword}&pageNo=${pageno}&size=${size}&
			&fields=qpCode,status,sectors,nsqfLevel,occupation,qpTempID,createdOn,jobRole,country,reviews,version,draftedOn,updated_at`;
		return this.apiService.get(qpDataURL);
	}

	getUploadFiles(url: any) {
		const getUploadFilesUrl = `${environment.documentServiceUrl}/api/document/v1/signedURL?key=${url}`;
		return this.apiService.get(getUploadFilesUrl);
	}

	searchExpoData(disabilitytype: any, disabilitycategory: any, status: any, keyword: any, pageNo: any, itemsPerPage: any) {
		// ,pageNo:any,itemsPerPage:any
		var disabilityUrl = "";
		var disabilitycategoryUrl = "";
		var statusUrl = "";
		if (disabilitytype) {
			disabilityUrl = 'disabilitytype:' + disabilitytype + ",";
		}
		if (disabilitycategory) {
			disabilitycategoryUrl = 'disabilitycategory:' + disabilitycategory + ",";
		}
		if (status) {
			statusUrl = 'statusID:' + status;
		}
		var seachData = disabilityUrl + disabilitycategoryUrl + statusUrl;
		var expositorySearch = seachData.replace(/,\s*$/, "");
		// &pageNo=${pageNo}&itemsPerPage=${itemsPerPage}&
		const searchExpoURL = `${environment.sqaServiceUrl}/api/sqa/expository/filter?matches=${expositorySearch}&pageNo=${pageNo}&itemsPerPage=${itemsPerPage}&keyword=${keyword}`;
		return this.apiService.get(searchExpoURL);
	}
	deleteQP(qpData: any) {
		console.log(qpData);
		const deleteQpUrl = `${environment.sqaServiceUrl}/api/sqa/qp?qpTempID=${qpData.qpTempID}&version=${qpData.version}`;
		return this.apiService.delete(deleteQpUrl, {
			qpCode: qpData.qpCode,
			version: qpData.version,
			status: qpData.status
		});
	}

	ApprovedExpositoryDetails(data: any): Observable < any > {
		const getApprovedDetailsUrl = environment.sqaServiceUrl + '/api/sqa/expository/approval';
		return this.apiService.put(getApprovedDetailsUrl, data);
	}
}
